import { ThemeConfig } from 'ant-design-vue/es/config-provider/context'

import { rumiTheme } from './theme'

export const ANT_DESIGN_THEME: ThemeConfig = {
  token: {
    colorPrimary: '#516E3A',
    // colorPrimary: rumiTheme.colors.rumi.brandGreen[800],
    colorWarning: rumiTheme.colors.rumi.orange[600],
    colorError: rumiTheme.colors.rumi.red[500],
    // colorSuccess: '#84a986',
    colorText: rumiTheme.colors.rumi.grey[700],
    // colorText: '#1d1d1b',

    // colorInfo: '#E8E8E2',
    // colorInfoBg: '#E8E8E280',
    // colorInfoBorder: '#E8E8E2',

    fontSize: 15,
    fontFamily: 'Inter, Arial, sans-serif',
    // motionBase: 16
  },
  components: {
    Alert: {
      colorErrorBg: rumiTheme.colors.rumi.red[200],
    },
    Badge: {
      colorErrorHover: rumiTheme.colors.rumi.red[500],
    },
    Breadcrumb: {
      colorText: rumiTheme.colors.rumi.grey[800],
      colorTextDescription: rumiTheme.colors.rumi.grey[600],
      colorBgTextHover: 'transparent',
      fontSize: 14,
    },
    Button: {
      colorLink: rumiTheme.colors.rumi.brandGreen[900],
      colorLinkActive: rumiTheme.colors.rumi.brandGreen[800],
      colorLinkHover: rumiTheme.colors.rumi.brandGreen[500],
      controlOutlineWidth: 0,
      controlHeightSM: 28,
      fontSizeLG: 16,
    },
    Card: {
      colorBorderSecondary: 'none',
      boxShadow: 'none',
    },
    Collapse: {
      colorFillAlter: 'transparent',
      // colorFillAlter: rumiTheme.colors.rumi.grey[200]
    },
    DatePicker: {
      borderRadiusLG: 6,
      controlHeightLG: 40,
      fontSizeLG: 18,
    },
    Dropdown: {
      controlItemBgActive: rumiTheme.colors.rumi.grey[300],
      controlItemBgActiveHover: rumiTheme.colors.rumi.grey[400],
    },
    Divider: {
      marginLG: 12,
    },
    Input: {
      borderRadiusLG: 6,
      fontSizeLG: 18,
      fontSize: 16,
      controlOutline: 'rgba(36, 66, 46, 0.1)',
    },
    Menu: {
      itemMarginInline: 0,
    },
    Modal: {
      fontWeightStrong: 500,
    },
    Notification: {
      colorSuccess: rumiTheme.colors.rumi.brandGreen[500],
    },
    Progress: {
      colorInfo: rumiTheme.colors.rumi.brandGreen[500],
    },
    Select: {
      borderRadiusLG: 6,
      fontSizeLG: 16,
      controlOutline: 'rgba(36, 66, 46, 0.1)',
    },
    Segmented: {
      colorBgLayout: '#F4F3ED',
      // colorBgElevated: '#596f5b',
      // colorText: '#fff'
    },
    Steps: {},
    Table: {
      colorBgContainer: 'transparent',
      colorFillAlter: '#FBFAF6',
      paddingSM: 8,
    },
    Tabs: {
      // fontFamily: rumiTheme.fontFamily.headings,
      margin: 30,
      colorFillAlter: 'white',
    },
    Tag: {
      // colorSuccessBg: '#9FB4A2',
      // colorSuccess: '#36484C'
    },
    Tooltip: {
      colorBgDefault: rumiTheme.colors.rumi.jungleGreen[900],
    },
    Typography: {
      colorLink: rumiTheme.colors.rumi.jungleGreen[700],
      colorLinkActive: rumiTheme.colors.rumi.jungleGreen[900],
      colorLinkHover: rumiTheme.colors.rumi.jungleGreen[900],
    },
  },
}
